package com.downdogapp.client.controllers.start

import com.downdogapp.client.LogEmitter
import com.downdogapp.client.View

interface Page : LogEmitter {

  val view: View
  val shouldDisplay: Boolean
  val title: String

  fun refreshPage()
  fun onBackClicked(): Boolean =
    false // Return true for this page to handle the back clicked, return false to let StartViewController handle it

  fun onScrolledFrom() {}
  fun onScrolledTo() {}
  fun onForegrounded() {}
}
